"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const router_1 = require("next/router");
const helpers_1 = require("../../lib/helpers");
const TabContext_1 = __importDefault(require("../../contexts/TabContext"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const useUrlParams_1 = require("../../hooks/useUrlParams");
function getDefaultTab(tabs) {
    return tabs[0];
}
const Tabs = (props) => {
    var _a;
    const { onTabChange: propsOnTabChange, hasIndicator = true, hrefMode, urlPropName, value } = props;
    const [urlParams, setUrlParam] = useUrlParams_1.useUrlParams();
    const router = router_1.useRouter();
    const currentUrlParam = urlParams[urlPropName !== null && urlPropName !== void 0 ? urlPropName : ''];
    /* URL Param overwrites initial tab. */
    let initialTab = (_a = value !== null && value !== void 0 ? value : currentUrlParam) !== null && _a !== void 0 ? _a : props.initialTab;
    if (hrefMode) {
        // remove query "?mode=test"
        // eslint-disable-next-line prefer-destructuring
        initialTab = helpers_1.withoutQueryParams(router.asPath);
    }
    const [currentTab, setCurrentTab] = react_1.useState(initialTab);
    const panelsRef = react_1.useRef([]);
    react_1.useEffect(() => {
        if (currentUrlParam) {
            setCurrentTab(currentUrlParam);
        }
    }, [currentUrlParam]);
    /* Keep it synced. */
    react_1.useEffect(() => {
        if (value && value !== currentTab) {
            setCurrentTab(value);
        }
    }, [value, currentTab]);
    const registerTabPanel = react_1.useCallback((tabName) => {
        /* This increments the length, so the next TabPanel in the stack will have a different name (+1) */
        if (!panelsRef.current.find((p) => p.name === tabName)) {
            panelsRef.current.push({
                name: tabName,
                href: props.href,
            });
        }
    }, [props.href]);
    const onTabChangeHandle = react_1.useCallback((newTabName) => {
        var _a;
        const foundTab = panelsRef.current.find((tab) => tab.name === newTabName);
        if (foundTab === null || foundTab === void 0 ? void 0 : foundTab.href) {
            router.push(foundTab.href).catch(console.error);
            return;
        }
        if (propsOnTabChange) {
            propsOnTabChange(newTabName);
        }
        setCurrentTab(newTabName);
        // set the url param
        if (urlPropName) {
            const isDefaultTab = ((_a = getDefaultTab(panelsRef.current)) === null || _a === void 0 ? void 0 : _a.name) === newTabName;
            if (isDefaultTab) {
                // remove it from our url bar, we dont need to see it since its default.
                setUrlParam(urlPropName, '');
            }
            else {
                setUrlParam(urlPropName, newTabName);
            }
        }
    }, [propsOnTabChange, router, setUrlParam, panelsRef, urlPropName]);
    const contextValue = react_1.useMemo(() => ({
        currentTab,
        hrefMode,
        hasIndicator,
        onTabChange: onTabChangeHandle,
        registerTabPanel,
        urlPropName,
        panelsRef,
    }), [currentTab, hasIndicator, hrefMode, onTabChangeHandle, registerTabPanel, urlPropName]);
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    return (react_1.default.createElement(TabContext_1.default.Provider, { value: contextValue },
        react_1.default.createElement("div", Object.assign({}, primitiveProps), props.children)));
};
exports.default = withJourney_1.default('j-tabs', Tabs);
